import React from "react";
import { makeStyles } from "@material-ui/styles";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableHeaderCellComponent from './TableHeaderCellComponent'

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    overflowY: "auto",
  },
  table: {
    //...
    height: "100%",
    overflowY: "scroll",
  },
}));

const TableComponent = (prop) => {
  const classes = useStyles();
  const headerColumns = prop.headerColumns;
  const body = prop.tableBody;

  return (
    <TableContainer className={classes.tableContainer}>
      <Table stickyHeader aria-label="sticky table" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableHeaderCellComponent columns={headerColumns} />
          </TableRow>
        </TableHead>
        <TableBody>
            {body}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableComponent;
